import { useState, useEffect } from 'react';
import cn from 'classnames';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { motion, useReducedMotion } from 'framer-motion';
import Logo from '../assets/svg/logo.svg';
import { ROUTES } from '../config/routes';
import NavLink from './common/NavLink';
import ThemeToggle from './common/ThemeToggle';
import useMatchMediaQuery from '../hooks/useMatchMediaQuery';
import { MATCHMEDIA } from '../config/constants';
import { HEADER, HEADER_ELEMENTS } from '../config/variants';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const isLargerScreen = useMatchMediaQuery(MATCHMEDIA.SMALL);
  const shouldReduceMotion = useReducedMotion();
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const onClick = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const body = document.querySelector('body');

    if (isNavOpen && !isLargerScreen) {
      body.classList.add('menu-open');
      body.classList.remove('menu-closed');
    } else {
      body.classList.add('menu-closed');
      body.classList.remove('menu-open');
    }
  }, [isNavOpen, isLargerScreen]);

  return (
    <motion.header
      variants={!shouldReduceMotion ? HEADER : null}
      animate="in"
      initial="out"
      className="header container flex-container"
    >
      <motion.div variants={!shouldReduceMotion ? HEADER_ELEMENTS : null}>
        <Link
          to="/"
          title={data.site.siteMetadata.title}
          className="logo"
        >
          <Logo />
        </Link>
      </motion.div>

      <div className="mobile-nav-wrapper">
        <button
          type="button"
          className={cn('mobile-nav-trigger', {
            active: isNavOpen,
          })}
          onClick={onClick}
        >
          <span className="visually-hidden">
            {isNavOpen ? 'Close Navigation' : 'Open Navigation'}
          </span>
        </button>
        <nav className={cn('mobile-nav', { active: isNavOpen })}>
          <ul>
          <li>
              <NavLink onClick={onClick} route={ROUTES.SERIES}>Series</NavLink>
            </li>
            <li>
              <NavLink onClick={onClick} route={ROUTES.ARTICLES}>Articles</NavLink>
            </li>
            <li>
              <NavLink onClick={onClick} route={ROUTES.ABOUT}>About</NavLink>
            </li>
            <li><ThemeToggle /></li>
          </ul>
        </nav>
      </div>
      <motion.nav
        variants={!shouldReduceMotion ? HEADER_ELEMENTS : null}
        className="main-nav"
      >
        <ul>
          <li><ThemeToggle /></li>
          <li>
            <NavLink route={ROUTES.SERIES}>Series</NavLink>
          </li>
          <li>
            <NavLink route={ROUTES.ARTICLES}>Articles</NavLink>
          </li>
          <li>
            <NavLink route={ROUTES.ABOUT}>About</NavLink>
          </li>
        </ul>
      </motion.nav>
    </motion.header>
  );
};

export default Header;
